import React from "react"

type SectionProps = {
    title?: string,
    subTitle?: string,
    hidden?: boolean,
    children?: React.ReactNode
}

function Section({title, subTitle, hidden, children}: SectionProps) {
    return <div hidden={hidden}>
        {title &&
          <div className="border-b border-gray-900/10 pb-4">
            <h2 className="text-base font-semibold leading-7 text-gray-900">{title}</h2>
              {subTitle &&
                <p className="mt-1 text-sm leading-6 text-gray-600">{subTitle}</p>}
          </div>}
        {children &&
          <div className="grid grid-cols-6 gap-3">
              {children}
          </div>}
    </div>
}

export {Section}